module.exports = __webpack_public_path__ + "img/icon_challange_banned.79418f3e.svg";